import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire CLIENTS section
*/
function Clients() {
  return <Outlet />;
}

export default Clients;
